import styles from "./check.module.css";

export default function Check({ label, onClick, disabled }) {
  return (
    <div className={styles.container}>
      <input type="checkbox" onClick={onClick && onClick} disabled={disabled} className={styles.check} />
      <label className={styles.label}>{label}</label>
    </div>
  );
}